import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getAllCourses, getCourse } from 'services/course';
import Course from 'services/course/models/course-interface';
import Content from 'services/course/models/content-interface';
import Trail from 'services/course/models/trail-interface';
import { LandingPageVideoModules, LandingPageModuleCard } from './style';
import { ChevronDown, Play, User, Heart, Baby, Stethoscope, Clock, BookOpen, Star } from 'lucide-react';

const VideoContent: React.FC = () => {
  const history = useHistory();
  const [moduleOne, setModuleOne] = useState<Course>();
  const [moduleTwo, setModuleTwo] = useState<Course>();
  const [moduleThree, setModuleThree] = useState<Course>();
  const [moduleFour, setModuleFour] = useState<Course>();
  const [openTab, setOpenTab] = useState<number>(0);

  useEffect(() => {
    (async () => {
      const token = 'Bearer ' + process.env.REACT_APP_UNLOGGED_TOKEN;

      const localCourses = await getAllCourses({}, { Authorization: token });
      const selectedCourse = localCourses[0]
        ? await getCourse(localCourses[0].trail_id, {
            Authorization: token,
          })
        : ({} as Trail);

      if (selectedCourse && selectedCourse.courses) {
        setModuleOne(selectedCourse.courses[0]);
        setModuleTwo(selectedCourse.courses[1]);
        setModuleThree(selectedCourse.courses[2]);
        setModuleFour(selectedCourse.courses[3]);
      }
    })();
  }, []);

  const handleTabChange = (tab: number): void => {
    if (openTab === tab) {
      setOpenTab(0);
    } else {
      setOpenTab(tab);
    }
  };

  const getModuleIcon = (index: number) => {
    const icons = [
      <User key="user" />,
      <Heart key="heart" />,
      <Baby key="baby" />,
      <Stethoscope key="stethoscope" />
    ];
    return icons[index] || <User key="default" />;
  };

  const getModuleData = (index: number, module?: Course) => {
    const modulesData = [
      {
        subtitle: 'Trimestre - O início da jornada',
        description: 'Do resultado positivo ao terceiro mês de gestação.',
        lessons: module?.contents?.length || 12
      },
      {
        subtitle: '2º Trimestre - Emoções a cada movimento', 
        description: 'Dois corpos em plena transformação.',
        lessons: module?.contents?.length || 8
      },
      {
        subtitle: '3º Trimestre - A reta final (que é apenas o começo)',
        description: 'Preparando-se para o grande primeiro encontro.',
        lessons: module?.contents?.length || 10
      },
      {
        subtitle: 'Pós-parto, cuidados com o recém-nascido e amamentação',
        description: 'Prazer te receber, meu bebê.',
        lessons: module?.contents?.length || 12
      }
    ];
    
    if (index < 0 || index >= modulesData.length) {
      return { subtitle: '', description: '', lessons: 0 };
    }

    return modulesData[index];
  };

  const modules = [
    { id: 1, title: 'Módulo 1', module: moduleOne },
    { id: 2, title: 'Módulo 2', module: moduleTwo },
    { id: 3, title: 'Módulo 3', module: moduleThree },
    { id: 4, title: 'Módulo 4', module: moduleFour }
  ];


  const totalLessons = [moduleOne, moduleTwo, moduleThree, moduleFour]
    .filter(m => m?.contents?.length)
    .reduce((total, m) => total + (m?.contents?.length || 0), 0) || 43;

  return (
    <LandingPageVideoModules>
      <div className="container-content">
        {/* Seção Esquerda - Módulos */}
        <div className="modules-section">
          <div>
            <h1> Ao seu lado, em todas as etapas </h1>
            <p>Um curso de gestantes completo e feito sob medida para acompanhar você mês a mês, até a amamentação</p>
          </div>
          
          <div className="modules-dropdown">

              
              {modules.map(({ id, title, module }, index) => {

                console.log("moduleOne no render:", moduleOne);

                const moduleData = getModuleData(index, module);
                return (
                  <LandingPageModuleCard key={id}>
                    <div className="module-header">
                      <div className="module-icon">
                        {getModuleIcon(index)}
                      </div>

                      <div className="module-content">
                        <div className="module-main">
                          <div className="module-info">
                            <h3 className="module-title">
                              {title}
                            </h3>
                            <p className="module-subtitle">
                              {moduleData.subtitle}
                            </p>
                            <p className="module-description">
                              {moduleData.description}
                            </p>

                            <div style={{display: "flex", justifyContent: "center", flexDirection: "column", alignContent: "center",}}>
                              <button
                                className="view-link"
                                onClick={() => handleTabChange(id)}
                              >
                                Veja quais são as aulas
                              </button>

                              <button
                                className="expand-button"
                                onClick={() => handleTabChange(id)}
                              >
                                <ChevronDown className={openTab === id ? 'rotated' : ''} />
                              </button>
                            </div>

                          </div>

                          <div className="module-controls">
                            <div className="lessons-badge">
                              {moduleData.lessons} aulas
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={`expandable-content ${openTab === id ? 'expanded' : ''}`}>
                      <div className="content-inner">
                        <div className="divider"></div>
                        <div className="lessons-list">
                          {module?.contents?.length ? (
                            module.contents.map((lesson: Content, lessonIndex: number) => (
                              <div key={lessonIndex} className="lesson-item">
                                <Play />
                                <span>{lesson.title}</span>
                              </div>
                            ))
                          ) : (
                            <div className="empty-content">
                              Conteúdo em breve
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </LandingPageModuleCard>
                );
              })}
          </div>
        </div>
        
        {/* Seção Direita - Informações */}
        <div className="info-section">
          {/* Detalhes do Curso */}
          <div className="course-details">
            <h2 className="course-title">Detalhes do curso</h2>
            <div className="stats-grid">
              <div className="stat-item">
                <div className="bg-icon">
                  <div className="stat-icon">
                      <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.5 8.25V15.5L20.3334 20.3334M20.3334 30H10.6666C5.32788 30 1 25.6721 1 20.3334V10.6666C1 5.32788 5.32788 1 10.6666 1H20.3334C25.6721 1 30 5.32788 30 10.6666V20.3334C30 25.6721 25.6721 30 20.3334 30Z" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </div>
                </div>
 
                <div className="stat-main-label">9h34min</div>
                <div className="stat-sublabel">Duração total</div>
              </div>
              <div className="stat-item">
                <div className="bg-icon">
                  <div className="stat-icon">
                    <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.595 6.87637V9.12316C15.595 11.1003 13.9772 12.718 12.0001 12.718C10.023 12.718 8.40527 11.1003 8.40527 9.12316V6.87637" stroke="white" stroke-miterlimit="22.926"/>
                    <path d="M6.60791 8.22458C6.60791 8.71887 7.01233 9.12329 7.50662 9.12329H8.40534M6.60791 7.77522C6.60791 7.28093 7.01245 6.8765 7.50662 6.8765H10.2028C11.1914 6.8765 12.0002 6.06766 12.0002 5.07907C12.0002 6.06766 12.809 6.8765 13.7976 6.8765H16.4938C16.9879 6.8765 17.3924 7.28093 17.3924 7.77522M15.5951 9.12329H16.4938C16.9881 9.12329 17.3924 8.71887 17.3924 8.22458" stroke="white" stroke-miterlimit="22.926"/>
                    <path d="M7.8286 14.7893C7.11143 14.5549 6.60791 13.9393 6.60791 13.1456V6.56121C6.60791 3.59546 9.03444 1.16893 12.0001 1.16893C14.9658 1.16893 17.3924 3.59546 17.3924 6.56121V13.1456C17.3924 13.9393 16.8888 14.5549 16.1717 14.7893" stroke="white" stroke-miterlimit="22.926"/>
                    <path d="M13.7975 14.0661C13.7975 15.0588 12.9927 15.8635 12.0001 15.8635C11.0073 15.8635 10.2026 15.0588 10.2026 14.0661" stroke="white" stroke-miterlimit="22.926"/>
                    <path d="M14.5015 30.9463H5.00513C5.00513 26.3358 5.52135 24.2778 7.82859 21.321C6.55193 19.1879 7.82853 17.0695 7.82853 17.0695L7.82859 14.7893M16.299 30.9463H15.4003M16.1717 14.7893L16.1717 17.0695C16.1717 17.0695 17.4483 19.1879 16.1717 21.321C18.4789 24.2778 18.9951 26.3358 18.9951 30.9463H17.1977" stroke="white" stroke-miterlimit="22.926"/>
                    <path d="M9.97046 21.2485C10.6001 21.005 11.2845 20.8714 12.0001 20.8714C12.7156 20.8714 13.4 21.005 14.0296 21.2485" stroke="white" stroke-miterlimit="22.926"/>
                    <path d="M1 26.7448L3.24679 27.1941M23 26.7448L20.7532 27.1941M23 29.4409L20.7532 28.9916M1 29.4409L3.24679 28.9916" stroke="white" stroke-miterlimit="2.613"/>
                    <path d="M18.5456 25.8789V16.7623C18.5456 15.7737 17.6938 15.2529 16.7482 14.9649L13.7974 14.0661V12.2331M5.45435 19.0091V25.8789M10.2026 12.2331V14.0661L7.25171 14.9649C6.30615 15.2529 5.45435 15.7738 5.45435 16.7623V18.1104" stroke="white" stroke-miterlimit="22.926"/>
                    <path d="M12.4495 3.41574H13.3482M14.2469 4.31445H15.1456" stroke="white" stroke-miterlimit="2.613"/>
                    </svg>
                  </div>
                </div>
                <div className="stat-main-label">Acesso</div>
                <div className="stat-sublabel">Individual</div>
              </div>
            </div>
          </div>

          {/* O que está incluído */}
          <div className="included-section">
            <h3 className="included-title">O que está incluído:</h3>
            <ul className="included-list">
              <li className="included-item">
                <span className="check-icon">✓</span>
                <span>Certificado</span>
              </li>
              <li className="included-item">
                <span className="check-icon">✓</span>
                <span>Aulas online gravadas</span>
              </li>
              <li className="included-item">
                <span className="check-icon">✓</span>
                <span>Material de apoio didático</span>
              </li>
              <li className="included-item">
                <span className="check-icon">✓</span>
                <span>Acesso vitalício</span>
              </li>
            </ul>
          </div>

          {/* Condição Especial */}
          <div className="special-section">
            <div className="special-badge">
              <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.44066 18.4922L11.1656 17.3913L13.1973 17.6366L14.2711 15.8941L16.2083 15.2335L16.4229 13.1982L17.8813 11.7625L17.1883 9.83631L17.8813 7.91005L16.4229 6.47432L16.2082 4.4391L14.2711 3.77845L13.1973 2.036L11.1656 2.28126L9.44066 1.18038L7.71574 2.28126L5.68401 2.036L4.61018 3.77845L2.67304 4.4391L2.45842 6.47432L0.999966 7.91005L1.69304 9.83631L0.999966 11.7625L2.45842 13.1983L2.67309 15.2335L4.61023 15.8942L5.68401 17.6366L7.71574 17.3913L9.44066 18.4922Z" stroke="white" stroke-miterlimit="10"/>
                <path d="M4.64562 9.83612C4.64562 12.4843 6.79239 14.6311 9.44061 14.6311C12.0888 14.6311 14.2356 12.4843 14.2356 9.83612C14.2356 7.1879 12.0888 5.04108 9.44061 5.04108C6.79239 5.04108 4.64562 7.1879 4.64562 9.83612Z" stroke="white" stroke-miterlimit="10"/>
                <path d="M4.14767 15.5073L2.16156 21.715L4.86662 21.5663L6.98299 23.2576L8.76196 17.6974" stroke="white" stroke-miterlimit="10"/>
                <path d="M14.7339 15.5073L16.72 21.715L14.0149 21.5663L11.8985 23.2576L10.1196 17.6974" stroke="white" stroke-miterlimit="10"/>
              </svg>
              <span>Condição Especial</span>
            </div>
            <p className="special-text">
              Aulas 100% gratuitas mediante cupom de acesso para todas as mamães que se inscreverem agora.
            </p>
            <div className='button-container'>
            <button className="cta-button" onClick={() => history.push('/signup')}>
                Inscreva-se Agora ›
              </button>
              <div className="guarantee-text">E aproveite todos esses benefícios para uma jornada ainda mais tranquila</div>
            </div>

          </div>
        </div>
      </div>
    </LandingPageVideoModules>
  );
};

export default VideoContent;